import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { CurrencyWithPlaceholderFallback } from './CurrencyWithPlaceholderFallback';

export const MinMonthlyRepaymentRow = ({
    amount
}: {
    amount: number | null;
}) => (
    <div
        className="flex items-center justify-between min-m:flex-col min-m:items-start min-m:gap-2xs"
        data-testid="min-monthly-repayment"
    >
        <Text>
            <FormattedMessage
                id="_.loan_summary.min_monthly_repayment"
                defaultMessage="Min. monthly repayment"
            />
        </Text>
        <Text className="text-m font-bold text-structure-100">
            <span className="min-m:hidden">
                <FormattedMessage
                    id="_.loan_summary.min_monthly_repayment_mobile"
                    defaultMessage="{amount} /month"
                    values={{
                        amount: (
                            <span className="text-l">
                                <CurrencyWithPlaceholderFallback
                                    value={amount}
                                />
                            </span>
                        )
                    }}
                />
            </span>
            <span className="hidden font-med min-m:inline">
                <FormattedMessage
                    id="_.loan_summary.min_monthly_repayment_desktop"
                    defaultMessage="{amount} per month"
                    values={{
                        amount: (
                            <span className="text-2xl font-bold">
                                <CurrencyWithPlaceholderFallback
                                    value={amount}
                                />
                            </span>
                        )
                    }}
                />
            </span>
        </Text>
    </div>
);
